module.exports = __webpack_public_path__ + "img/_R4A5707.c00f4341.jpg";